import {Component, OnInit} from '@angular/core';
import {AppConfig} from '../services/AppConfig';
import {environment} from '../../environments/environment';

@Component({
    selector: 'app-badge-test',
    templateUrl: './badge-test.component.html',
    styleUrls: ['./badge-test.component.css']
})
export class BadgeTestComponent implements OnInit {
    IS_ENV_TEST: boolean;
    app_name: any;
    colorBdg: string;

    constructor(private appConf: AppConfig) {
    }

    ngOnInit() {
        this.IS_ENV_TEST = !environment.production;
        this.colorBdg = this.IS_ENV_TEST ? 'FEB410' : '17A2B8';
        this.app_name = environment.version.desc;
        this.IS_ENV_TEST = this.IS_ENV_TEST;
    }

}
